<template>
    <div>
        <PillFilterControl :options="options" :value="value" @input="update($event)" />
    </div>
</template>

<script>
import PillFilterControl from '@/components/common/PillFilterControl.vue';

export default {
    data() {
        return {
            options: [{
                description: "All",
                code: "all"
            }, {
                description: "World",
                code: "world"
            }, {
                description: "National",
                code: "national"
            }, {
                description: "Regional",
                code: "regional"
            }, {
                description: "State",
                code: "state"
            }, {
                description: "G5",
                code: "g5"
            }, {
                description: "AAU",
                code: "aau"
            }, {
                description: "Marquee",
                code: "marquee"
            }]
        };
    },
    props: ["value"],
    methods: {
        update(item) {
            this.$emit('input', item);
        }
    },
    components: {
        PillFilterControl
    }
}
</script>